import CategoryModalCtrl from '../../modals/category/ctrl'

export default class topNav {
  constructor ($rootScope, ModalService) {
    this.$rootScope = $rootScope
    this.descriptionVisible = false
    this.categoryDescription = ''
    this.categoryMoreLink = ''

    this.ModalService = ModalService
    $rootScope.$on('categoryClear', () => {
      this.descriptionVisible = false
    })

    $rootScope.$on('categorySelected', () => {
      this.descriptionVisible = true
    })

  }

  openCategoryModal (category) {
    this.ModalService.showModal({
      template: require('../../modals/category/view.html'),
      controller: CategoryModalCtrl,
      controllerAs: 'modal',
      inputs: {
        category: category
      },
      appendElement: angular.element(document.querySelector('#app-wrapper'))
    })
  }

  selectCategory (item) {
    if (item.selected) {
      item.selected = false
      this.$rootScope.$emit('categoryClear')
      this.categoryDescription = item.description
      return
    }

    for (let el of this.$rootScope.categories) {
      el.selected = false
    }

    this.$rootScope.$emit('categorySelected', item)
    this.categoryDescription = item.description
    this.categoryMoreLink = item.link
    this.selectedCategory = item;
    item.selected = true
  }

}


// WEBPACK FOOTER //
// ./src/app/directives/app-nav/ctrl.js